import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=94d3306c&scoped=true"
import script from "./AttachmentList.vue?vue&type=script&lang=ts"
export * from "./AttachmentList.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentList.vue?vue&type=style&index=0&id=94d3306c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d3306c",
  null
  
)

export default component.exports